var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toMoney, toPercentage, toDateTime } from 'helpers/Format';
import Report from '../components/Report';
var Sales = /** @class */ (function (_super) {
    __extends(Sales, _super);
    function Sales() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sales.prototype.componentDidMount = function () {
        this.props.store.reports.readInvoices();
    };
    Sales.prototype.render = function () {
        var _this = this;
        var reports = this.props.store.reports;
        var headers = this.props.store.UI.isDesktop
            ? ['number', 'date', 'netAmount', 'discount', 'taxAmount', 'total']
            : ['number', 'date', 'total'];
        var items = reports.invoices.sort(function (a, b) { return a.id - b.id; });
        return (React.createElement(Report, { header: headers, items: items, loading: !reports.invoicesLoaded, keyExtractor: function (invoice) { return String(invoice.id); }, format: function (invoices) {
                return invoices.map(function (invoice) { return (__assign(__assign({}, invoice), { date: toDateTime(invoice.date), discount: toPercentage(invoice.discount), netAmount: toMoney(invoice.netAmount), taxAmount: toMoney(invoice.taxAmount), taxBase: toMoney(invoice.taxBase), total: toMoney(invoice.total) })); });
            }, onSelectItem: function (item) {
                console.log('item: ', item);
                var clientName = _this.props.store.users.user.client;
                var url = "https://ticket.ticando.net/?client=".concat(clientName, "&numero=").concat(item.numero, "&hide=true");
                window.open(url, '_blank');
            } }));
    };
    Sales = __decorate([
        inject('store'),
        observer
    ], Sales);
    return Sales;
}(Component));
export default Sales;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/Sales.tsx
// module id = 1150
// module chunks = 0